<template>
	<div
		class="list H5page_bookShelf"
		:class="is_web_css_bookShelf"
		:style="{
			minHeight: '100vh',
			backgroundImage: 'url(' + (data.backgroundImage == '' ? require('../../assets/img/gf-ver1/background.png') : data.backgroundImage) + ')',
			marginTop: data.marginTop + 'px',
		}"
	>
		<div v-if="is_Template">
			<img v-if="data.titleImage != ''" :src="data.titleImage" class="top" />
			<img v-else src="../../assets/img/gf-ver1/top.png" class="top" />
			<div class="book-list">
				<div class="book">
					<div class="book-item">
						<img src="@/assets/img/gf-ver1/1.png" />
						<img src="@/assets/img/gf-ver1/block.png" class="block" />
					</div>
					<div class="book-item">
						<img src="@/assets/img/gf-ver1/2.png" />
						<img src="@/assets/img/gf-ver1/block.png" class="block" />
					</div>
					<div class="book-item">
						<img src="@/assets/img/gf-ver1/3.png" />
						<img src="@/assets/img/gf-ver1/block.png" class="block" />
					</div>
					<div class="book-item">
						<img src="@/assets/img/gf-ver1/3.png" />
						<img src="@/assets/img/gf-ver1/block.png" class="block" />
					</div>
					<div class="book-item">
						<img src="@/assets/img/gf-ver1/3.png" />
						<img src="@/assets/img/gf-ver1/block.png" class="block" />
					</div>
					<div class="book-item"></div>
				</div>
			</div>
			<div class="bottom">
				<img src="../../assets/img/ly/bottom.png" />
				<div class="bottom-text">共5本</div>
			</div>
		</div>

		<div v-if="!is_Template">
			<img v-if="data.titleImage != ''" :src="data.titleImage" class="top" />
			<img v-else src="../../assets/img/gf-ver1/top.png" class="top" />
			<div class="book-list">
				<div class="book" v-for="(item, index) in bookTableData" :key="index">
					<div class="book-item" v-for="(ele, index) in item" :key="index" @click="openModel(ele)">
						<img :src="ele.contentLinkUrl" />
						<img src="@/assets/img/gf-ver1/block.png" class="block" v-if="ele.redeemCount <= 0" />
						<div class="bookName" v-if="ele.bookName">{{ ele.bookName }}</div>
					</div>
					<img src="../../assets/img/ly/line.png" class="line" />
				</div>
			</div>

			<div class="bottom">
				<img src="../../assets/img/ly/bottom.png" />
				<div class="bottom-text">共{{ bookNum }}本</div>
			</div>
		</div>

		<div class="model-box" v-if="modelShow">
			<img src="../../assets/img/gf-ver1/modallight.png" class="modal-light" />
			<div class="modal">
				<img :src="currentInfo.popupImage" class="modal-top" />
				<div class="modal-content">
					<div class="modal-handle">
						<input type="text" class="modal-center" placeholder="请输入卡号" v-model="inputValue" v-if="currentInfo.redeemCount == 0" />
						<img src="../../assets/img/gf-ver1/modalactive.png" class="modal-btn" @click="activeAuth" v-if="currentInfo.redeemCount == 0" />
						<img src="../../assets/img/gf-ver1/modallook.png" class="modal-btn" @click="activeAuth" v-else />
					</div>
					<img src="../../assets/img/gf-ver1/modal-close.png" class="modal-close" @click="closeModal" />
				</div>
			</div>
		</div>
		<div v-loading.fullscreen.lock="loading"></div>
	</div>
</template>

<script>
import axios from 'axios';
import { Toast, Dialog } from 'vant';
export default {
	name: 'bookShelf',
	props: ['data', 'className'],
	data() {
		return {
			aiId: '',
			bookNum: 0,
			is_Template: true,
			bookTableData: [],
			surplusNum: 3, // 一行中剩余的位置
			loading: false,
			token: '',
			// token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJmZjgwODA4MTdkYzYwMmQ5MDE3ZGM3OTNlOTNkMDAwYiIsImV4cCI6MTY1NDY2NTA2MH0.MlQhS6xIbix9JaqFqSHw-rKafbrOhhmp9LoZ1DPvBdg',
			inputValue: '',
			modelShow: false,
			currentInfo: {}, //存放这本书的信息
			is_web_css_bookShelf: '',
		};
	},
	mounted() {
		if (!navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
			this.is_web_css_bookShelf = 'is_web_css_bookShelf';
		}
		if (this.data.aiId && this.data.aiId != '' && this.data.aiId != 'null') {
			this.getBookTableData(this.data.aiId);
		}
	},
	methods: {
		//获取书架上有多少书
		getBookTableData(aiId) {
			var url = process.env.VUE_APP_BASE_API + '/act/book/listH5?aiId=' + aiId + '';
			axios.get(url, { headers: { Authorization: 'Bearer ' + this.data.token, clientOs: 'h5' } }).then((res) => {
				this.aiId = aiId;
				this.is_Template = false;
				var newBookTableData = res.data.rows;
				if (newBookTableData.length > 0) {
					for (var i = 0; i < newBookTableData.length; i++) {
						if (newBookTableData[i].bookStatusCode == 'YX') {
							this.bookTableData.push(newBookTableData[i]);
						}
					}
					this.bookNum = this.bookTableData.length;
				}

				//让书架的每一本书对齐  不够的补空
				if (Number(3 - (this.bookNum % 3)) == 3) {
					this.surplusNum = 0;
				} else {
					this.surplusNum = Number(3 - (this.bookNum % 3));
				}
				for (let index = 0; index < this.surplusNum; index++) {
					this.bookTableData.push({});
				}
				let arr = [];
				let allArr = [];
				this.bookTableData.forEach((ele, index) => {
					arr.push(ele);
					if ((index + 1) % 3 == 0) {
						allArr.push(arr);
						arr = [];
					}
				});
				this.bookTableData = allArr;
			});
		},

		// 关闭弹窗
		closeModal() {
			this.inputValue = '';
			this.modelShow = false;
		},

		//跳转
		toHref() {
			//激活跳转
			if (this.currentInfo.redeemCount == '0') {
				if (this.currentInfo.popupActivate == '1') {
					this.bookIntroductionPage();
				} else {
					// location.href = './booktop.html?type=gf&id=1';
					location.href = './booktop.html?abId=' + this.currentInfo.abId + '&token=' + this.data.token;
				}
				//查看跳转
			} else {
				if (this.currentInfo.popupCheck == '1') {
					this.bookIntroductionPage();
				} else {
					location.href = './booktop.html?abId=' + this.currentInfo.abId + '&token=' + this.data.token;
				}
			}
		},
		//跳转书籍介绍页
		bookIntroductionPage() {
			const params = { aiId: this.currentInfo.aiId, abId: this.currentInfo.abId, apName: '书籍介绍落地页' };
			let url = process.env.VUE_APP_BASE_API + '/act/page/listH5';
			axios.get(url, { params: params, headers: { Authorization: 'Bearer ' + this.data.token, clientOs: 'h5' } }).then((res) => {
				if (res.data.code == 200) {
					if (res.data.rows && res.data.rows.length > 0) this.$router.push({ path: '/H5Page?id=' + res.data.rows[0].apId });
				} else {
					Dialog({ message: res.data.msg });
				}
			});
		},

		//打开弹框
		openModel(item) {
			this.currentInfo = item;
			this.inputValue = '';
			this.modelShow = true;
		},
		//提交兑换码
		activeAuth() {
			if (this.currentInfo.redeemCount == 0) {
				if (!this.inputValue || this.inputValue.trim() == '') {
					Toast('请输入卡号');
					return;
				}
				this.checkCode();
			} else {
				this.toHref();
			}
		},
		//验证输入的兑换码
		checkCode() {
			this.loading = true;
			const params = { aiId: this.currentInfo.aiId, abId: this.currentInfo.abId, redeemCode: this.inputValue.trim() };
			let url = process.env.VUE_APP_BASE_API + '/act/bookRedeemRecord/activate';
			axios.post(url, params, { headers: { Authorization: 'Bearer ' + this.data.token, clientOs: 'h5' } }).then((res) => {
				this.loading = false;
				console.log(res);
				if (res.data.code == 200) {
					this.modelShow = false;
					this.toHref();
				} else {
					Dialog({ message: res.data.msg });
				}
			});
		},
	},
};
</script>

<style scoped>
.list {
	position: relative;
	width: 100%;
	height: auto;
	min-height: 100%;
	/* background: url('../../assets/img/gf-ver1/background.png'); */
	background-repeat: no-repeat;
	background-size: 100% 100%;
}

.top {
	display: block;
	width: 100%;
	/* position: fixed;
	top: 0;
	left: 0;
	z-index: 999; */
}

.bottom {
	/* position: fixed;
	left: 0;
	bottom: 0; */
	width: 100%;
	z-index: 99;
}
.bottom > img {
	display: block;
	width: 100%;
}
.bottom-text {
	position: absolute;
	left: 0;
	bottom: 24px;
	width: 100%;
	text-align: center;
	font-weight: 500;
	color: #e1c59f;
}

.book-list {
	height: 100%;
	/* padding-top: 110px; 
	padding-bottom: 120px;*/
}
.book {
	position: relative;
	width: 100%;
	/* display: flex;
	justify-content: space-around;
	align-items: center;
	margin-bottom: -10px;
	background-size: 100% 100%;
	margin-top: 30px;
	flex-wrap: wrap; */
}
/* .book:first-child {
	margin-top: 0px;
} */
.book-item {
	position: relative;
	/* width: 25%; */
	width: 33.33%;
	margin-top: 30px;
	float: left;
	text-align: center;
}
/* .book-item:not(:nth-child(3n)) {
	margin-right: calc(4% / 2);
} */
.book-item > img {
	/* width: 100%; */
	width: 70%;
}
.book-item > .block {
	position: absolute;
	width: 14px;
	/* right: 0; */
	right: 15%;
	top: 50%;
	margin-top: -6px;
}
.bookName {
	background-image: url(../../assets/images/bookNameBak.png);
	background-size: 100% 100%;
	background-repeat: no-repeat;
	color: #ffffff;
	font-size: 10px;
	width: 100%;
	height: 40px;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0 4%;
	margin-bottom: -50px;
}
.line {
	width: 100%;
}
/* 弹窗 */
.model-box {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.7);
	z-index: 101;
}
.modal-light {
	position: absolute;
	width: 100%;
	z-index: -1;
}

.modal {
	position: absolute;
	top: 50%;
	left: 0;
	width: 100%;
	transform: translateY(-50%);
	z-index: 2;
}
.modal-top {
	display: block;
	width: 351px;
	margin: 0 auto;
}
.modal-content {
	position: relative;
	/* margin-top: -28px; */
}
.modal-back {
	display: block;
	width: 351px;
	margin: 0 auto;
}
.modal-handle {
	width: 100%;
}
.modal-center {
	display: block;
	width: 280px;
	height: 42px;
	margin: 0 auto;
	font-size: 16px;
	font-weight: 500;
	color: #666;
	text-indent: 16px;
	background: #fff;
	border: none;
	border-radius: 5px;
}
.modal-title {
	display: block;
	height: 18px;
	margin: 16px auto 42px;
}
.modal-btn {
	display: block;
	width: 136px;
	height: 36px;
	margin: 28px auto;
}
.modal-close {
	display: block;
	width: 40px;
	margin: 28px auto;
}

.manager {
	position: absolute;
	top: 18px;
	right: 6px;
	display: inline-block;
	width: 40px;
}
</style>